export const radioTheme = {
  baseStyle: {},

  variants: {
    withImage: {
      container: {
        w: 'full',
        border: '1px solid',
        borderRadius: '10px',
        borderColor: 'white',
        pl: '30px',
        userSelect: 'none',
        shadow: 'card',

        _checked: {
          borderColor: 'selectionColor',
        },
      },

      label: {
        w: 'full',
        fontSize: '16px',
        py: '4px',
        px: '4px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      },

      control: {
        borderColor: 'reno.grey300',
        borderRadius: 'full',
        border: '1px solid',
        w: '24px',
        h: '24px',

        _invalid: {
          borderColor: 'reno.red',
          color: 'reno.red',
        },

        _checked: {
          color: 'selectionColor',
          borderColor: 'selectionColor',
          bg: 'white',
        },
      },
    },
  },
};
